import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import useFilter from "../../../../../hook/useFilter"
import useVariable from "../../../../../hook/useVariable"
import { producttypeActions } from "../../../../../store/producttype-slice"
import Pagination from "./pagination"
import { Link } from "react-router-dom"
import InfoIcon from "../../../../InfoIcon"
import { faLayerGroup, faStore } from "@fortawesome/free-solid-svg-icons"

const Filter = (props) => {

    let defaultproducttypecount = useSelector((state) => state.producttype.filterProducttypeCount)
    let pagination = useSelector((state) => state.producttype.pagination)

    let sliceFilters = useSelector(state => state.producttype.filter)
    let sliceActions = producttypeActions
    let sliceItems = useSelector(state => state.producttype.producttypes)
    const [isMount, setIsMount] = useState(false)

    const { children } = props


    let dispatch = useDispatch()

    const { doFilter } = useFilter()
    const { variableValue } = useVariable()

    const [paginationItems, setPaginationItems] = useState([])

    useEffect(() => {
        let items = []
        if (pagination) {
            pagination.map((item, key) => {

                items.push(<Pagination key={key} producttypes={item} index={key} />)
            })
        }

        setPaginationItems(items)
    }, [pagination])



    useEffect(() => {

        if (!isMount) {
            setIsMount(true)
            return
        }

        doFilter(sliceFilters, sliceItems, sliceActions)


    }, [sliceFilters])

    

    return <div className="p-3" >
        <div style={{ display: 'flex', justifyContent: 'space-between' }} >
            <div>
                <label>Pagination</label> <select name="filter-pagination" defaultValue={sliceFilters.pagination} className="mb-2" onChange={(event) => {
                    let value = variableValue(event.target.value)

                    dispatch(producttypeActions.setFilter({
                        key: 'pagination',
                        value
                    }))



                }} >
                    <option value='' >All</option>

                    {
                        defaultproducttypecount.map((item, key) => {

                            return <option key={key} value={item} >{item}</option>
                        })
                    }
                </select>

                <input type="text" name="filter-product_title-order_id" className="mb-2" defaultValue={sliceFilters.search} placeholder="title" onInput={(event) => {
                    let value = variableValue(event.target.value)


                    dispatch(producttypeActions.setFilter({
                        key: 'search',
                        value
                    }))


                }} />
            </div>
<div>
    
       <Link className="btn btn-outline-secondary bgnt mb-2" to='/admin/producttype' ><InfoIcon icon={faLayerGroup} />New Producttype</Link>
</div>
        </div>
        {children}
        <div className="pagination-container">{paginationItems}</div>
       
    </div>
}


export default Filter